import MenuButton from "./MenuButton";

const ClaimOptionsWidget = ({ actions }) => {
  const phoneNumber = "+919561222072";
  const landline = "020-66893248";
  const email = "mailto:claims@acuvisor.com";

  return (
    <div className="w-full text-xs">
      {/* Call Us Button */}
      <button
        onClick={() => (window.location.href = `tel:${phoneNumber}`)}
        className="border border-black/20 hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
      >
        📞 +91 9561222072
      </button>

      <button
        onClick={() => (window.location.href = `tel:${landline}`)}
        className="border border-black/20 hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
      >
        ☎️ 020-66893248
      </button>

      {/* Email Button */}
      <button
        onClick={() => window.open(email, "_blank")}
        className="border border-black/20 hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
      >
        📧 claims@acuvisor.com
      </button>

      <button
        onClick={() => window.open("https://acuvisor.com/claim", "_blank")}
        className="border border-black/20 hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
      >
        🌐 Claim Page
      </button>

      <MenuButton actions={actions} />
    </div>
  );
};

export default ClaimOptionsWidget;
